import { render, staticRenderFns } from "./SCheckups.vue?vue&type=template&id=15a5a34a&"
import script from "./SCheckups.vue?vue&type=script&lang=js&"
export * from "./SCheckups.vue?vue&type=script&lang=js&"
import style0 from "./SCheckups.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports